import React from 'react';
import {createPortal} from 'react-dom';
import './style/model.scss';
import {FiX} from 'react-icons/fi';

interface LBPropsInterface{
  visible:boolean,
  closeModel:()=>void
}

const LBModel:React.FC<LBPropsInterface> = props =>{
  const {visible,children,closeModel} = props;

  if(visible){
    return createPortal(
      <div className="ecn-lightbox-Model">
        <div className="backdrop" onClick={closeModel}>
        </div>
        <FiX className="ecn-lightbox-Model-close" onClick={closeModel}/>
        <div className="ecn-lightbox-Model-content">
          {children}
        </div>
      </div>,
      document.body
    )
  }else{
    return <></>
  }
}

export default LBModel;